import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const DICT = {
  en: {
    brand: "EC DREAM",
    tagline: "Predict. Play. Earn Rewards.",
    home: "Home", about: "About", how_it_works: "How It Works", events: "Events",
    contact: "Contact", support: "Support", login: "Login", create_account: "Create Account",
    logout: "Logout", dashboard: "Dashboard", my_predictions: "My Predictions", balance: "Balance",
    spin: "Spin", referral: "Referral", kyc: "KYC", profile: "Profile", settings: "Settings",
    notifications: "Notifications",
    hero_title: "Turn Your Sports Instinct Into Real Rewards",
    hero_sub: "Predict match winners, stake your balance, and earn published reward percentages. Spin daily, refer friends, and grow your dream fund.",
    get_started: "Get Started", explore_events: "Explore Events",
    company_info: "Company Information",
    about_text: "EC DREAM is a premium prediction and rewards platform where members forecast event outcomes and earn transparent, admin-published rewards. Every calculation is automatic and visible.",
    how_step1: "Create your account", how_step1d: "Register in seconds with your email or Google, and add your referral code.",
    how_step2: "Predict events", how_step2d: "Pick a team, stake from your balance, and confirm before the closing time.",
    how_step3: "Earn rewards", how_step3d: "When results are published, winnings are auto-credited to your balance.",
    upcoming_events: "Upcoming Events", no_events: "No events available right now.",
    contact_us: "Contact Us", get_support: "Need Help?",
    thank_you: "THANK YOU",
    current_balance: "Current Balance", total_rewards: "Total Rewards", total_used: "Total Used",
    referral_rewards: "Referral Rewards", bonuses: "Bonuses", recent_activity: "Recent Activity",
    predict_now: "Predict Now", select_team: "Select Team", amount: "Amount", confirm: "Confirm",
    cancel: "Cancel", reward_percentage: "Reward %", event: "Event", date_time: "Date / Time",
    confirm_prediction: "Confirm Prediction", selected_team: "Selected Team",
    prediction_id: "Prediction ID", status: "Status", final_result: "Final Result",
    reward_amount: "Reward Amount", teams: "Teams",
    email: "Email", password: "Password", name: "Name", mobile: "Mobile",
    confirm_password: "Confirm Password", referral_code: "Referral Code",
    forgot_password: "Forgot Password?", show: "Show", hide: "Hide",
    no_account: "Don't have an account?", have_account: "Already have an account?",
    sign_in: "Sign In", sign_up: "Sign Up", or: "OR", continue_google: "Continue with Google",
    daily_spin: "Daily Spin", spin_now: "SPIN", spin_history: "Spin History",
    spin_used: "You already spun today. Come back after 12:00 AM.",
    your_ref_code: "Your Referral Code", ref_link: "Referral Link", copy: "Copy", copied: "Copied!",
    total_referrals: "Total Referrals", active_referrals: "Active Referrals",
    ref_history: "Referral History",
    submit_kyc: "Submit KYC", full_name: "Full Name", id_number: "ID Number", address: "Address",
    id_front: "ID Front", id_back: "ID Back", profile_photo: "Profile Photo",
    additional_docs: "Additional Document", upload: "Upload", submit: "Submit",
    kyc_status: "KYC Status", not_submitted: "Not Submitted",
    save: "Save", language: "Language", email_notifications: "Email Notifications",
    subject: "Subject", message: "Message", send: "Send", my_tickets: "My Tickets",
    admin_login: "Admin Login", admin_dashboard: "Admin Dashboard", members: "Members",
    total_members: "Total Members", active_members: "Active Members", pending_kyc: "Pending KYC",
    active_events: "Active Events", completed_events: "Completed Events", predictions: "Predictions",
    referrals: "Referrals", spin_activity: "Spin Activity", total_balance: "Total Balance (PKR)",
    create_event: "Create Event", edit: "Edit", publish_result: "Publish Result",
    winner: "Winner", view_predictions: "View Predictions", approve: "Approve", reject: "Reject",
    reason: "Reason", adjust_balance: "Adjust Balance", lock: "Lock", unlock: "Unlock",
    broadcast: "Broadcast", title: "Title", reply: "Reply", audit_logs: "Audit Logs",
    all_predictions: "All Predictions", spin_control: "Spin Control", loading: "Loading...",
    welcome_back: "Welcome back", server_time: "Server Time",
    team_a: "Team A", team_b: "Team B", closing_time: "Closing Time", time: "Time",
    mark_all_read: "Mark all read", no_notifications: "No notifications yet.",
    insufficient: "Insufficient balance",
    deposit: "Deposit", withdrawal: "Withdrawal", payment_method: "Payment Method",
    withdrawal_method: "Withdrawal Method", txn_id: "Transaction ID",
    upload_slip: "Upload Payment Slip", submit_deposit: "Submit Deposit",
    submit_withdrawal: "Submit Withdrawal", account_details: "Account Details",
    total_deposit: "Total Deposit", total_withdrawal: "Total Withdrawal",
    total_profit: "Total Profit / Rewards", total_bonus: "Total Bonus",
    my_deposits: "My Deposits", my_withdrawals: "My Withdrawals",
    deposit_mgmt: "Deposits", withdrawal_mgmt: "Withdrawals",
    transaction_history: "Transaction History", view_slip: "View Slip",
    processing: "Processing", request_amount: "Amount to deposit",
    withdraw_amount: "Amount to withdraw",
    ads_mgmt: "Ads", payment_settings: "Payment Settings", protection: "Protection",
    aviator: "Aviator", aviator_mgmt: "Aviator Game",
    three_cups: "Three Cups", three_cups_mgmt: "Three Cups Game",
    dnd: "Deal or No Deal", dnd_mgmt: "Deal or No Deal",
  },
  ur: {
    brand: "EC DREAM",
    tagline: "پیش گوئی کریں۔ کھیلیں۔ انعامات کمائیں۔",
    home: "ہوم", about: "ہمارے بارے میں", how_it_works: "یہ کیسے کام کرتا ہے", events: "ایونٹس",
    contact: "رابطہ", support: "سپورٹ", login: "لاگ ان", create_account: "اکاؤنٹ بنائیں",
    logout: "لاگ آؤٹ", dashboard: "ڈیش بورڈ", my_predictions: "میری پیش گوئیاں", balance: "بیلنس",
    spin: "اسپن", referral: "ریفرل", kyc: "کے وائی سی", profile: "پروفائل", settings: "ترتیبات",
    notifications: "اطلاعات",
    hero_title: "اپنے کھیل کے اندازے کو حقیقی انعامات میں بدلیں",
    hero_sub: "میچ کے فاتح کی پیش گوئی کریں، اپنا بیلنس لگائیں اور شائع شدہ انعامی فیصد کمائیں۔ روزانہ اسپن کریں، دوستوں کو ریفر کریں۔",
    get_started: "شروع کریں", explore_events: "ایونٹس دیکھیں",
    company_info: "کمپنی کی معلومات",
    about_text: "یہ ایک پریمیم پیش گوئی اور انعامی پلیٹ فارم ہے جہاں ممبران ایونٹ کے نتائج کی پیش گوئی کرتے ہیں اور شفاف انعامات کماتے ہیں۔",
    how_step1: "اپنا اکاؤنٹ بنائیں", how_step1d: "ای میل یا گوگل کے ساتھ سیکنڈوں میں رجسٹر کریں۔",
    how_step2: "پیش گوئی کریں", how_step2d: "ٹیم منتخب کریں، بیلنس لگائیں اور تصدیق کریں۔",
    how_step3: "انعامات کمائیں", how_step3d: "نتائج شائع ہونے پر انعام خودکار طور پر شامل ہو جاتا ہے۔",
    upcoming_events: "آنے والے ایونٹس", no_events: "اس وقت کوئی ایونٹ دستیاب نہیں۔",
    contact_us: "ہم سے رابطہ کریں", get_support: "مدد چاہیے؟",
    thank_you: "شکریہ",
    current_balance: "موجودہ بیلنس", total_rewards: "کل انعامات", total_used: "کل استعمال شدہ",
    referral_rewards: "ریفرل انعامات", bonuses: "بونس", recent_activity: "حالیہ سرگرمی",
    predict_now: "ابھی پیش گوئی کریں", select_team: "ٹیم منتخب کریں", amount: "رقم", confirm: "تصدیق کریں",
    cancel: "منسوخ", reward_percentage: "انعام فیصد", event: "ایونٹ", date_time: "تاریخ / وقت",
    confirm_prediction: "پیش گوئی کی تصدیق", selected_team: "منتخب ٹیم",
    prediction_id: "پیش گوئی آئی ڈی", status: "اسٹیٹس", final_result: "حتمی نتیجہ",
    reward_amount: "انعامی رقم", teams: "ٹیمیں",
    email: "ای میل", password: "پاس ورڈ", name: "نام", mobile: "موبائل",
    confirm_password: "پاس ورڈ کی تصدیق", referral_code: "ریفرل کوڈ",
    forgot_password: "پاس ورڈ بھول گئے؟", show: "دکھائیں", hide: "چھپائیں",
    no_account: "اکاؤنٹ نہیں ہے؟", have_account: "پہلے سے اکاؤنٹ ہے؟",
    sign_in: "سائن ان", sign_up: "سائن اپ", or: "یا", continue_google: "گوگل کے ساتھ جاری رکھیں",
    daily_spin: "روزانہ اسپن", spin_now: "اسپن", spin_history: "اسپن ہسٹری",
    spin_used: "آپ آج اسپن کر چکے ہیں۔ 12:00 بجے کے بعد آئیں۔",
    your_ref_code: "آپ کا ریفرل کوڈ", ref_link: "ریفرل لنک", copy: "کاپی", copied: "کاپی ہو گیا!",
    total_referrals: "کل ریفرلز", active_referrals: "فعال ریفرلز",
    ref_history: "ریفرل ہسٹری",
    submit_kyc: "کے وائی سی جمع کریں", full_name: "پورا نام", id_number: "شناختی نمبر", address: "پتہ",
    id_front: "شناختی کارڈ سامنے", id_back: "شناختی کارڈ پیچھے", profile_photo: "پروفائل فوٹو",
    additional_docs: "اضافی دستاویز", upload: "اپ لوڈ", submit: "جمع کریں",
    kyc_status: "کے وائی سی اسٹیٹس", not_submitted: "جمع نہیں کیا گیا",
    save: "محفوظ کریں", language: "زبان", email_notifications: "ای میل اطلاعات",
    subject: "موضوع", message: "پیغام", send: "بھیجیں", my_tickets: "میرے ٹکٹ",
    admin_login: "ایڈمن لاگ ان", admin_dashboard: "ایڈمن ڈیش بورڈ", members: "ممبران",
    total_members: "کل ممبران", active_members: "فعال ممبران", pending_kyc: "زیر التواء کے وائی سی",
    active_events: "فعال ایونٹس", completed_events: "مکمل ایونٹس", predictions: "پیش گوئیاں",
    referrals: "ریفرلز", spin_activity: "اسپن سرگرمی", total_balance: "کل بیلنس (روپے)",
    create_event: "ایونٹ بنائیں", edit: "ترمیم", publish_result: "نتیجہ شائع کریں",
    winner: "فاتح", view_predictions: "پیش گوئیاں دیکھیں", approve: "منظور", reject: "مسترد",
    reason: "وجہ", adjust_balance: "بیلنس ایڈجسٹ کریں", lock: "لاک", unlock: "ان لاک",
    broadcast: "براڈکاسٹ", title: "عنوان", reply: "جواب", audit_logs: "آڈٹ لاگز",
    all_predictions: "تمام پیش گوئیاں", spin_control: "اسپن کنٹرول", loading: "لوڈ ہو رہا ہے...",
    welcome_back: "خوش آمدید", server_time: "سرور ٹائم",
    team_a: "ٹیم اے", team_b: "ٹیم بی", closing_time: "بندش کا وقت", time: "وقت",
    mark_all_read: "سب پڑھا ہوا نشان زد کریں", no_notifications: "ابھی کوئی اطلاع نہیں۔",
    insufficient: "ناکافی بیلنس",
    deposit: "ڈپازٹ", withdrawal: "نکلوائیں", payment_method: "ادائیگی کا طریقہ",
    withdrawal_method: "نکلوانے کا طریقہ", txn_id: "ٹرانزیکشن آئی ڈی",
    upload_slip: "ادائیگی سلپ اپ لوڈ کریں", submit_deposit: "ڈپازٹ جمع کریں",
    submit_withdrawal: "نکلوانے کی درخواست", account_details: "اکاؤنٹ کی تفصیلات",
    total_deposit: "کل ڈپازٹ", total_withdrawal: "کل نکلوایا گیا",
    total_profit: "کل منافع / انعامات", total_bonus: "کل بونس",
    my_deposits: "میرے ڈپازٹس", my_withdrawals: "میری نکلوائی",
    deposit_mgmt: "ڈپازٹس", withdrawal_mgmt: "نکلوائی",
    transaction_history: "ٹرانزیکشن ہسٹری", view_slip: "سلپ دیکھیں",
    processing: "کارروائی جاری", request_amount: "ڈپازٹ رقم",
    withdraw_amount: "نکلوانے کی رقم",
    ads_mgmt: "اشتہارات", payment_settings: "ادائیگی کی ترتیبات", protection: "تحفظ",
    aviator: "ایویایٹر", aviator_mgmt: "ایویایٹر گیم",
    three_cups: "تین کپ", three_cups_mgmt: "تین کپ گیم",
    dnd: "ڈیل یا نو ڈیل", dnd_mgmt: "ڈیل یا نو ڈیل",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ecfd_lang") || "en");

  useEffect(() => {
    localStorage.setItem("ecfd_lang", lang);
    document.documentElement.setAttribute("dir", lang === "ur" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "ur" : "en")), []);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, toggle }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
